module.exports = __webpack_public_path__ + "img/everyday-toons.b1eb393f.jpg";